import { Formik } from 'formik';
import React, { useState } from 'react';
import {
  Alert,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';
import { Link, useHistory, useParams } from 'react-router-dom';
import LoadingOverlay from '../LoadingOverlay';
import PageTitle from '../helpers/PageTitle';

function ResetPassword() {
  let history = useHistory();
  let { token } = useParams();
  const [message, setMessage] = useState(null);

  return (
    <Container>
      <Row>
        <Col>
          <PageTitle title={'Reset Password'} />
        </Col>
      </Row>
      <Row className='justify-content-center mt-3'>
        <Col md={6}>
          <Formik
            initialValues={{ password: '', cpassword: '' }}
            validate={(values) => {
              const errors = {};

              if (!values.password) {
                errors.password = 'Required';
              } else if (values.password !== values.cpassword) {
                errors.cpassword = 'Please confirm your new password';
              }

              return errors;
            }}
            onSubmit={(values, actions) => {
              fetch(
                process.env.REACT_APP_AUTH_API_URL +
                  'api/forgot-password/consume',
                {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    service: 'fruition'
                  },
                  body: JSON.stringify({
                    token: token,
                    password: values.password
                  })
                }
              )
                .then((res) => {
                  if (res.ok) history.push('');
                  else if (res.status === 404) {
                    setMessage({
                      variant: 'warning',
                      message:
                        'The supplied password reset token could not be found'
                    });
                    actions.setSubmitting(false);
                  } else throw Error(res.statusText);
                })
                .catch((err) => {
                  if (process.env.NODE_ENV === 'development')
                    console.error(err);

                  setMessage({
                    variant: 'danger',
                    message: 'Sorry something went wrong'
                  });
                  actions.setSubmitting(false);
                });
            }}
          >
            {(props) => (
              <Card>
                <Card.Body>
                  {message ? (
                    <Alert
                      variant={message.variant}
                      onClose={() => {
                        setMessage(null);
                      }}
                      dismissible
                    >
                      {message.message}
                    </Alert>
                  ) : null}
                  <Form noValidate onSubmit={props.handleSubmit}>
                    <Form.Group controlId='password'>
                      <Form.Label>New Password</Form.Label>
                      <Form.Control
                        type='password'
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        value={props.values.password}
                        placeholder='Enter your new password'
                        isInvalid={props.errors.password}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {props.errors.password}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group controlId='cpassword'>
                      <Form.Label>Confirm Password</Form.Label>
                      <Form.Control
                        type='password'
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                        value={props.values.cpassword}
                        placeholder='Confirm your new password'
                        isInvalid={props.errors.cpassword}
                      />
                      <Form.Control.Feedback type='invalid'>
                        {props.errors.cpassword}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <div className='d-flex justify-content-center'>
                      <Button
                        className='mr-2'
                        variant='outline-secondary'
                        as={Link}
                        to=''
                      >
                        Cancel
                      </Button>
                      <Button variant='primary' type='submit'>
                        Submit
                      </Button>
                    </div>
                  </Form>
                  {props.isSubmitting ? <LoadingOverlay /> : null}
                </Card.Body>
              </Card>
            )}
          </Formik>
        </Col>
      </Row>
    </Container>
  );
}

export default ResetPassword;

